function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genFormItemStyle = function genFormItemStyle(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    // 标题
    color: 'rgba(0, 0, 0, 0.45)',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '18px',
    paddingBottom: '16px'
  }, "&-required", {
    color: '#FF4D4F',
    fontFamily: 'SimSong',
    lineHeight: '22px',
    paddingRight: '4px'
  }), "&-help", {
    paddingLeft: '4px',
    cursor: 'pointer'
  }), "&-label", {
    paddingBottom: '4px'
  }), "&-content", {
    color: '#0D1121',
    fontSize: 14,
    fontWeight: 400
  }), "&-error", {
    // 此字段是必填项，请填写后提交
    color: '#F5222D',
    fontSize: 12
  }))];
};